import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, message } from "antd";
import { LockOutlined, MobileOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import moment from "moment-jalaali";
function Register01({
  onSetSmsExpiresAt,
  onSetRegisteredMobile,
  registeredMobile,
}) {
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
const mobileInput = useRef();
useEffect(() =>{
  mobileInput.current?.focus();
})
  const REGISTER01 = gql`
    mutation Register01($authRegister1Input: AuthRegister1Input!) {
      authRegister1(authRegister1Input: $authRegister1Input) {
        expiresAt
      }
    }
  `;

  const [runRegister01, register01] = useMutation(REGISTER01, {
    onCompleted(data) {
      const smsExpiresAt = moment().diff(data?.authRegister1?.expiresAt, "second")
      onSetSmsExpiresAt(Math.abs(smsExpiresAt));
      onSetRegisteredMobile(mobile);
      message.info(`کد یکبار مصرف به شماره ${mobile} ارسال شد.`);
    },
    onError(error) {
      setError(error.message);
    },
  });

  function doRegister01(authRegister1Input) {
    runRegister01({
      variables: {
        authRegister1Input,
      },
    });
  }

  return (
    <div>
      <Form name="normal_login" className="login-form" onFinish={doRegister01} onValuesChange={() => setError("")}>
        <Form.Item
          style={{ marginBottom: "30px" }}
          name="mobile"
          rules={[
            {
              required: true,
              message: "لطفا شماره همراه خود را وارد کنید!",
            },
            {
              pattern: /^09[0-9]{9}$/,
              message: "فرمت موبایل صحیح نیست!"
            }
          ]}
          validateStatus={error ? "error" : undefined}
        >
          <Input
            size="large"
            className="form-input"
            prefix={<MobileOutlined className="site-form-item-icon" />}
            placeholder="شماره همراه"
            onChange={(e) => setMobile(e.target.value)}
            ref={mobileInput}
          />
        </Form.Item>

        <Form.Item
          name="password"
          style={{ marginBottom: "30px" }}
          rules={[
            {
              required: true,
              message: "لطفا رمز عبور خود را وارد کنید!",
            },
          ]}
          validateStatus={error ? "error" : undefined}
          help={error || undefined}
        >
          <Input.Password
            size="large"
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="رمز عبور"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            className="login-form-button"
            htmlType="submit"
            loading={register01.loading && true}
          >
            ارسال کد
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default Register01;
